<template>
  <IQOS :title="$t('chain_general.title')" required>
    <BaseInput
      class="mt-16"
      :placeholder="$t('chain_general.name_ph')"
      maxlength="36"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.name"
    />

    <BaseTextarea
      class="w-100 mt-16"
      :placeholder="$t('chain_general.desc_ph')"
      :disabled="!editing"
      :rows="8"
      v-model="edit_fields.description"
    />
    <!-- <BaseInput
      class="w-100 mt-16"
      :placeholder="$t('settings_cafe.cafe_info.price_policy')"
      readonly
      :value="`${edit_fields.price_level || '$'}`"
      v-if="!editing"
    /> -->
    <BaseSelect
      class="w-100 mt-16"
      :disabled="!editing"
      v-model="edit_fields.price_level"
    >
      <option :value="null" disabled>
        {{ $t("settings_cafe.cafe_info.option") }}
      </option>
      <option value="$">$</option>
      <option value="$$">$$</option>
      <option value="$$$">$$$</option>
      <option value="$$$$">$$$$</option>
    </BaseSelect>


    <template #actions>
      <IQOSActions
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>

export default {
  data() {
    return {
      editing: false,

      edit_fields: {
        name: null,
        logo: null,
        description: null,
        price_level: null,
      },
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;

      Object.keys(this.edit_fields).forEach(k => {
          this.$store.commit('setChainData', {
            key: k,
            value: this.edit_fields[k]
        });
      });

      this.$store.dispatch('saveChain');
    },
    reset() {
      this.edit_fields.name = this.chain.name;
      this.edit_fields.logo = this.chain.logo;
      this.edit_fields.description = this.chain.description;
      this.edit_fields.price_level = this.chain.price_level;
    },
    onImageChange(sizes) {
        this.edit_fields.logo = sizes.md;
    }
  },
  computed: {
    chain() {
      return this.$store.state.selected_chain;
    },
    logoImage() {
      const placeholder = "/icons/cafe-placeholder.jpg";

      if (this.editing) {
        return this.edit_fields.logo || placeholder;
      } else {
        return this.chain.logo || placeholder;
      }
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style scoped>
.cafe-image {
  border-radius: 1vh;
  object-fit: cover;
  height: auto;
  width: 100%;
}
.cafe-image-uploader {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  width: 100%;
}

.info-inputs {
  margin-top: 2vh;
}

.cafe-input {
  width: 100%;
  /* margin-top: 1vh; */
}

.blur {
  filter: blur(2px);
}
</style>